<div class="slide-toogle" [ngClass]="{'active': control.value === true, 'disabled': control.disabled}" (click)="toogle()">
  <div class="toogle"  [ngClass]="{'disabled': control.disabled}"></div>
</div>